import React from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Main from "../components/Main";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import PerfectScrollbar from "react-perfect-scrollbar";

const MainLayout = ({ children, location }) => {
  return (
    <React.Fragment>
      <div className="wrapper">
        <Main>
          <Navbar modifiers={["shrink", "stick-top"]} />
          <TransitionGroup className="main-content">
            <CSSTransition key={location.key} timeout={300} classNames="fade">
              <PerfectScrollbar>
                <div className="main-layout-content">{children}</div>
              </PerfectScrollbar>
            </CSSTransition>
          </TransitionGroup>
          <Footer />
        </Main>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.api_auth,
});

export default withRouter(connect(mapStateToProps)(MainLayout));
